<template>
  <div>
    <b-row>
      <b-col cols="2" style="padding-right: 0;height: 100vh;overflow-y: auto;max-width: 19%;">
        <SidebarMenu
          :menu="menu"
          :relative="true"
          :width="'16rem'"
          :showOneChild="true"
          :theme="'black-theme'"
        />
      </b-col>
      <b-col cols="10">
        <transition name="fade">
          <router-view />
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { SidebarMenu } from "vue-sidebar-menu";
export default {
  name: "PRIClientProfilePage",
  components: {
    SidebarMenu
  },
  data() {
    return {
      menu: [
        {
          href:
            "/pri-client-profile/" + this.$route.params.id + "/configuration",
          title: "Configuration"
          //   icon: "fa fa-chart-area"
        },
        {
          href:
            "/pri-client-profile/" + this.$route.params.id + "/thirdparties",
          title: "Third Parties"
          //   icon: "fa fa-chart-area"
        },
        {
          href:
            "/pri-client-profile/" +
            this.$route.params.id +
            "/tpi-custom-attributes",
          title: "Manage Custom Attributes"
          //   icon: "fa fa-chart-area"
        },
        // {
        //   href:
        //     "/pri-client-profile/" +
        //     this.$route.params.id +
        //     "/pri-control-group-categories",
        //   title: "Control Groups"
        //   //   icon: "fa fa-chart-area"
        // },
        // {
        //   href:
        //     "/pri-client-profile/" +
        //     this.$route.params.id +
        //     "/pri-control-group-categories-population",
        //   title: "Control Groups Population"
        //   //   icon: "fa fa-chart-area"
        // },
        {
          href: "/pri-client-profile/" + this.$route.params.id + "/identifiers",
          title: "Identifiers "
          //   icon: "fa fa-chart-area"
        }
      ]
    };
  },
  computed: {},
  methods: {},
  mounted() {}
};
</script>

<style scoped>
</style>
